// extracted by mini-css-extract-plugin
export var scrollArea = "_pa-0";